import React, { FC, memo, useEffect } from 'react';
import { useStyles } from './UserNotRegistered.styles';
import { useNavigate, useLocation } from 'react-router';
import { useAuth } from '@shared/hooks/useAuth';
import { paths } from '@shared/enums/paths';
import { useTitle } from '@shared/hooks/useTitle';
import { pageTitles } from '@shared/enums/pageTitles';
import { signOutCustom } from '@shared/helpers/auth';

const UserNotRegisteredComponent: FC = () => {
  const styles = useStyles();
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const setPageTitle = useTitle();
  const { state } = useLocation();

  useEffect(() => {
    setPageTitle(pageTitles.unauthorizedPage);
  }, []);

  useEffect(() => {
    if (currentUser) {
      navigate(paths.root);
    }
  }, [currentUser]);

  return (
    <div className={styles.root}>
      <p className={styles.heading}>{state?.email ?? 'This email'} is not registered with Rocky</p>
      <p className={styles.subHeading}>Please, Try logging out and selecting another account.</p>
      <button className={styles.signoutButton} onClick={signOutCustom}>
        Log out
      </button>
    </div>
  );
};

export const UserNotRegistered = memo(UserNotRegisteredComponent);
